@if (false ) {
  <div class="modal-content">
    <div class="modal-header">
        <h5 class="modal-title" id="otpModalLabel">Enter Verification Code</h5>
        <!-- <button type="button" class="btn-close" (click)="dis()"></button> -->
    </div>
    <form [formGroup]="otpForm">
      <div class="modal-body text-center">
        <p class="mb-4">Please enter the 6-digit code sent to your device</p>
        <div class=" otp-container" formArrayName="otps">
          <input
              *ngFor="let control of otpForm.controls['otps']['controls']; let i = index"
              [formControlName]="i" (keypress)="onlyNumbers($event)" (paste)="onPaste($event,i)" type="text" [id]="'otpInput' + i"
              (input)="onInput($event, i)" (keydown)="onKeyDown($event,i)"
              maxlength="1"
              class="w-14 h-14 text-center text-2xl form-control otp-input font-extrabold text-slate-900 bg-slate-100 border border-transparent hover:border-slate-200 appearance-none rounded outline-none focus:bg-white focus:border-indigo-400 focus:ring-2 focus:ring-indigo-100">
      </div>

        <div id="errorMessage" class="alert alert-danger d-none mt-3" role="alert">
            Please enter a valid 6-digit OTP
        </div>

        <div class="mt-3">
            <small class="text-muted">
                Didn't receive the code?
                <a href="#" id="resendOtp" [class.disabled]="disableButton" class="text-decoration-none cursor-pointer">Resend OTP in <span class="timer">{{timerMessage}} sec</span></a>
            </small>
        </div>
    </div>
    </form>
    <div class="modal-footer">
        <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button> -->
        <button type="button" class=" gradient-btn" (click)="verifyOtp()" id="verifyOtp">Verify OTP</button>
    </div>
  </div>
}

<!-- <div class="container mt-5">
  <button type="button" class="btn btn-primary btn-lg" data-bs-toggle="modal" data-bs-target="#securityModal">
      <i class="fas fa-file-invoice-dollar me-2"></i>
      Access Expense Dashboard
  </button>
</div> -->

<!-- Security Verification Modal -->
<!-- <div class="modal fade security-modal" id="securityModal" tabindex="-1" aria-labelledby="securityModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered"> -->
      <div class="modal-content">
          <!-- Step 1: Security Warning -->
          <div *ngIf="!otpRequested" class="step-content">
              <div class="security-header">
                  <i class="fas fa-shield-alt lock-icon"></i>
                  <h4 class="modal-title">Secure Access Required</h4>
                  <p class="mb-0">Expense Dashboard Verification</p>
              </div>

              <div class="modal-body">
                  <div class="step-indicator">
                      <div class="step active">1</div>
                      <div class="step inactive">2</div>
                      <div class="step inactive">3</div>
                  </div>

                  <div class="security-warning">
                      <div class="d-flex">
                          <i class="fas fa-exclamation-triangle me-3 mt-1"></i>
                          <div>
                              <h6 class="mb-2"><strong>Important Security Notice</strong></h6>
                              <p class="mb-0">The <strong>Expense Dashboard</strong> contains sensitive financial information and is restricted to authorized personnel only. To proceed, please verify your identity through OTP verification.</p>
                          </div>
                      </div>
                  </div>

                  <!-- <div class="text-center mb-4">
                      <h6><i class="fas fa-info-circle text-primary me-2"></i>Why verification is required:</h6>
                      <ul class="list-unstyled text-start mt-3">
                          <li><i class="fas fa-check text-success me-2"></i>Protect confidential expense data</li>
                          <li><i class="fas fa-check text-success me-2"></i>Ensure compliance with security policies</li>
                          <li><i class="fas fa-check text-success me-2"></i>Prevent unauthorized access</li>
                          <li><i class="fas fa-check text-success me-2"></i>Maintain audit trail</li>
                      </ul>
                  </div> -->

                  <div class="contact-info">
                      <h6 class="mb-3"><i class="fas fa-paper-plane me-2"></i>OTP will be sent to:</h6>
                      <!-- <div class="contact-method">
                          <i class="fas fa-mobile-alt"></i>
                          <span>Mobile: <span class="masked">{{'+91 ●●●●●●●234'}}</span></span>
                      </div> -->
                      <div class="contact-method">
                          <i class="fas fa-envelope"></i>
                          <span>Email: <span class="masked">{{userData.email}}</span></span>
                      </div>
                  </div>

                  <div class="alert alert-info">
                      <i class="fas fa-clock me-2"></i>
                      <small>The OTP will expire in <strong>5 minutes</strong> for your security.</small>
                  </div>
              </div>

              <div class="modal-footer">
                  <button (click)="dis()" type="button" class="btn btn-outline-secondary" >
                      <i class="fas fa-times me-2"></i>Cancel
                  </button>
                  <button type="button" class="btn btn-primary" (click)="getOtp()">
                      <i class="fas fa-paper-plane me-2"></i>Send OTP & Proceed
                  </button>
              </div>
          </div>

          <!-- Step 2: OTP Input -->
          <div *ngIf="otpRequested && !otpVerified" class="step-content">
              <div class="security-header">
                  <i class="fas fa-key lock-icon"></i>
                  <h4 class="modal-title">Enter Verification Code</h4>
                  <p class="mb-0">Check your email</p>
              </div>

              <div class="modal-body">
                  <div class="step-indicator">
                      <div class="step completed">
                          <i class="fas fa-check"></i>
                      </div>
                      <div class="step active">2</div>
                      <div class="step inactive">3</div>
                  </div>

                  <div class="text-center mb-4">
                      <p>We've sent a 6-digit verification code to:</p>
                      <div class="contact-info">
                          <!-- <div class="contact-method justify-content-center">
                              <i class="fas fa-mobile-alt"></i>
                              <span class="masked">+91 ●●●●●●●234</span>
                          </div> -->
                          <div class="contact-method justify-content-center">
                              <i class="fas fa-envelope"></i>
                              <span class="masked">{{userData.email}}</span>
                          </div>
                      </div>
                  </div>
                  <form [formGroup]="otpForm">
                  <div class=" otp-container" formArrayName="otps">
                    <input
                        *ngFor="let control of otpForm.controls['otps']['controls']; let i = index"
                        [formControlName]="i" type="text" [id]="'otpInput' + i"
                        (input)="onInput($event, i)" (keypress)="onlyNumbers($event)" (paste)="onPaste($event,i)" (keydown)="onKeyDown($event,i)"
                        maxlength="1"
                        class="w-14 h-14 text-center text-2xl form-control otp-input font-extrabold text-slate-900 bg-slate-100 border border-transparent hover:border-slate-200 appearance-none rounded outline-none focus:bg-white focus:border-indigo-400 focus:ring-2 focus:ring-indigo-100">
                  </div>
                </form>

                  <div id="otpTimer" class="text-center mb-3">
                      <small class="text-muted">
                          <i class="fas fa-stopwatch me-1"></i>
                          Code expires in: <span id="countdown" class="fw-bold text-danger">{{minutes +':' +seconds}}</span>
                      </small>
                  </div>

                  <div *ngIf="!otpVerified && otpSubmitted" class="alert alert-danger" role="alert">
                      <i class="fas fa-exclamation-triangle me-2"></i>
                      <span id="errorText">Please enter a valid 6-digit OTP</span>
                  </div>

                  <div class="text-center">
                      <small class="text-muted">
                          Didn't receive the code?
                          <a [class.disabled]="disableButton" (click)="getOtp()" id="resendOtp" class="text-decoration-none cursor-pointer">
                              <i class="fas fa-redo me-1"></i>Resend OTP in <span class="timer">{{timerMessage}} sec</span>
                          </a>
                      </small>
                  </div>
              </div>

              <div class="modal-footer">
                  <!-- <button type="button" class="btn btn-outline-secondary" (click)="otpRequested = false">
                      <i class="fas fa-arrow-left me-2"></i>Back
                  </button> -->
                  <button (click)="verifyOtp()" type="button" class="btn btn-success" id="verifyOtp">
                      <i class="fas fa-shield-check me-2"></i>Verify & Access
                  </button>
              </div>
          </div>

          <!-- Step 3: Success -->
          <div *ngIf="otpVerified" class="step-content">
              <div class="modal-body text-center py-5">
                  <div class="verification-success">
                      <i class="fas fa-check-circle"></i>
                      <h4 class="text-success mb-3">Access Granted!</h4>
                      <p class="text-muted mb-4">Identity verified successfully. Redirecting to Expense Dashboard...</p>

                      <div class="spinner-border text-success" role="status">
                          <span class="visually-hidden">Loading...</span>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  <!-- </div>
</div> -->
